import React from "react";
import contextProvider from "../../contextProvider";
import { withRouter } from "react-router-dom";
import { Row, Col } from "reactstrap";
import _ReactOBaseComponent from "../../_L0_components/_ReactOBaseComponent";
// import ReactOTooltip from "../../_L1_components/Elements/ReactOTooltip";
import ReactOButton from "../../_L1_components/Elements/ReactOButton";
import Panel from "../../_L1_components/Layout/Panel";

class StepCard extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: true,
      data: null,
    };
    super(props, initState);
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    // console.log("this.props ->", this.props);
  }

  onComponentWillUnmount() {}

  getImgUrl() {
    let url = "";
    // console.log(this.props);
    if (this.props.box_data.result && !this.props.box_data.discearly) {
      if (this.props.box_data.jpegid && this.props.res_id) {
        url =
          this.getAppContext().getApiStoreService().getCluster() +
          this.getAppContext().conf.API_PATH +
          "/utils/chromescreenstream/" +
          this.props.match.params.probeuid +
          "/" +
          this.props.match.params.measureid +
          "/" +
          this.props.bssid.replace(/:/g, "") +
          "/" +
          this.props.res_id +
          "." +
          this.props.box_data.jpegid +
          ".jpeg" +
          "?token=" +
          this.getAppContext().authHandler.getToken();
      } else {
        url = this.getAppContext().conf.PUBLIC_PATH + "images/thumb_code_3.jpg";
      }
    } else {
      url = this.getAppContext().conf.PUBLIC_PATH + "images/nodata_icon.png";
    }

    return url;
  }

  onRender() {
    return (
      <Panel
        className={
          this.props.box_data.heading
            ? "headBackground"
            : !this.props.box_data.end
            ? this.props.collapse == this.props.card_id && !this.props.box_data.discearly
              ? "activeBoxColor"
              : "hoverColor"
            : this.props.collapse == this.props.card_id && !this.props.box_data.discearly
            ? "activeBoxColor"
            : "hoverColorEnd"
        }
        rounded
        borderPrimary
        bodyClassName="p-0"
      >
        <Row noGutters className="p-2">
          <Col xs={4}>
            <div className="probe-photo" style={{ position: "relative" }}>
              <div
                className={`bg-cover rounded ${
                  this.props.box_data.discearly || !this.props.box_data.result
                    ? "border border-2"
                    : ""
                }`}
                style={{
                  paddingBottom: "100%",
                  background: "url(" + this.getImgUrl() + ") center center no-repeat",
                }}
              />
            </div>
          </Col>

          <Col xs={6} className="pl-2">
            <div
              className={window.innerWidth < 1600 ? "" : "mb-2"}
              // style={this.props.box_data.end ? { marginTop: "3em" } : {}}
            >
              {/* className="text-truncate" */}
              <div className="text-truncate d-flex" title={this.props.box_data.name}>
                <h5
                  className={
                    !this.props.box_data.result ||
                    this.props.box_data.summary[1] == "nan" ||
                    this.props.box_data.discearly
                      ? "text-gray500"
                      : undefined
                    // !this.props.box_data.end &&
                    // !this.props.box_data.result &&
                    // (this.props.box_data.summary[1] == "nan" ||
                    //   !/^(\d+)$/.test(this.props.box_data.summary[1]))
                    //   ? "text-gray500"
                    //   : undefined
                  }
                >
                  {this.props.box_data.subStep
                    ? this.props.box_data.subStep.name +
                      (this.props.box_data.subStep.numStep != null
                        ? " " +
                          this.props.box_data.subStep.numStep +
                          "/" +
                          this.props.box_data.subStep.totalStep
                        : "")
                    : this.props.box_data.name}
                </h5>
              </div>
              {/* <span>{this.props.card_id}</span> */}

              {this.props.box_data.subStep ? (
                <div className="text-muted text-truncate">
                  {this.props.box_data.subStep.subName}
                </div>
              ) : null}
            </div>
            {(this.props.box_data.info &&
              /^(\d+)$/.test(this.props.box_data.summary[1])) ||
            this.props.box_data.summary[1] == "nan" ? (
              <div>
                {this.props.box_data.summary[1] != "nan" && (
                  <div>
                    <small className="text-muted mb-2">
                      <strong>STATUS: </strong>
                    </small>
                    <span>
                      {this.props.box_data.summary &&
                      this.props.box_data.summary[1] &&
                      !/^-$/.test(this.props.box_data.summary[1]) ? (
                        /^(\d+)$/.test(this.props.box_data.summary[1]) ? (
                          <span className="text-success"> OK</span>
                        ) : (
                          <span className="text-danger"> ERROR</span>
                        )
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                )}
                {this.props.box_data.summary[1] == "nan" ||
                (!/^-$/.test(this.props.box_data.summary[1]) &&
                  this.props.box_data.result) ? (
                  <div
                    className={
                      this.props.box_data.summary[1] == "nan" ? "text-gray500" : undefined
                    }
                  >
                    <small
                      className={
                        this.props.box_data.summary[1] == "nan"
                          ? "mb-2"
                          : "text-muted mb-2"
                      }
                    >
                      <strong>TIME: </strong>
                    </small>
                    <span>
                      {this.props.box_data.summary &&
                      this.props.box_data.summary[1] &&
                      !/^(\d+)$/.test(this.props.box_data.summary[1])
                        ? "-"
                        : this.props.box_data.summary[1]}{" "}
                      {this.props.box_data.summary[1] != "nan" && "ms"}
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : null}
            {this.props.box_data.summary[1] != "nan" &&
              !/^(\d+)$/.test(this.props.box_data.summary[1]) &&
              !this.props.box_data.end &&
              this.props.box_data.result && (
                <div>
                  <span>
                    {this.props.box_data.summary &&
                    this.props.box_data.summary[1] &&
                    !/^-$/.test(this.props.box_data.summary[1]) ? (
                      this.props.box_data.execStep &&
                      this.props.box_data.subStep &&
                      !/^(\d+)$/.test(this.props.box_data.summary[1]) ? (
                        ""
                      ) : /^(\d+)$/.test(this.props.box_data.summary[1]) ? (
                        <div>
                          <small className="text-muted mb-2">
                            <strong>STATUS: </strong>
                          </small>
                          <span className="text-success"> OK</span>
                        </div>
                      ) : (
                        <div>
                          <small className="text-muted mb-2">
                            <strong>STATUS: </strong>
                          </small>
                          <span className="text-danger"> ERROR</span>
                        </div>
                      )
                    ) : (
                      ""
                    )}
                  </span>
                </div>
              )}
            {this.props.box_data.extraInfo ? (
              <div
                title={this.props.box_data.extraInfo}
                className="text-danger text-truncate"
              >
                {this.props.box_data.extraInfo}
              </div>
            ) : null}
            <div
              style={
                this.props.box_data.end
                  ? { marginTop: "4em" }
                  : { position: "absolute", bottom: "0" }
              }
            >
              <span
                className="text-muted mt-3"
                style={
                  this.getAppContext().media.isMobile
                    ? { fontSize: "12px" }
                    : { fontSize: "18px" }
                }
              >
                {this.props.box_data.result != "_HEADING_" &&
                  this.props.box_data.mp4id && (
                    <span
                      title="Play video"
                      onClick={(e) => {
                        e.stopPropagation();
                        let chromiumSize;
                        let _TMP_split = this.props.box_data.result.split("|");
                        _TMP_split.forEach((_C_data) => {
                          let _TMP_regex_res = /^\s*SIZE:\s(.*)\s*$/.exec(_C_data);
                          if (_TMP_regex_res) {
                            chromiumSize = parseFloat(_TMP_regex_res[1]).toFixed(1);
                          }
                        });
                        let chromiumVideo =
                          this.props.box_data.mp4id &&
                          this.getAppContext().momentjs().unix() -
                            this.props.match.params.ts <
                            86400 * 60
                            ? this.props.res_id + "." + this.props.box_data.mp4id + ".mp4"
                            : undefined;

                        let objVideo = {
                          url:
                            this.getAppContext().getApiStoreService().getCluster() +
                            this.getAppContext().conf.API_PATH +
                            "/utils/chromescreenstream/" +
                            this.props.match.params.probeuid +
                            "/" +
                            this.props.match.params.measureid +
                            "/" +
                            this.props.bssid.replace(/:/g, "") +
                            "/" +
                            chromiumVideo +
                            "?token=" +
                            this.getAppContext().authHandler.getToken(),
                          chromiumVideo: chromiumVideo,
                          bssid: this.props.bssid.replace(/:/g, ""),
                          size: chromiumSize,
                        };

                        this.props._overlap_modal_video.open(objVideo);
                      }}
                      className="icon-file-video button-card pr-1"
                    />
                  )}
                {/* lmp4 */}
                {this.props.box_data.result != "_HEADING_" &&
                  this.props.box_data.lmp4id && (
                    <span
                      title="Play video"
                      onClick={(e) => {
                        e.stopPropagation();
                        let chromiumSize;
                        let _TMP_split = this.props.box_data.result.split("|");
                        _TMP_split.forEach((_C_data) => {
                          let _TMP_regex_res = /^\s*SIZE:\s(.*)\s*$/.exec(_C_data);
                          if (_TMP_regex_res) {
                            chromiumSize = parseFloat(_TMP_regex_res[1]).toFixed(1);
                          }
                        });
                        let chromiumLmp4 =
                          this.props.box_data.lmp4id &&
                          this.getAppContext().momentjs().unix() -
                            this.props.match.params.ts <
                            86400 * 60
                            ? this.props.res_id +
                              "." +
                              this.props.box_data.lmp4id +
                              ".lmp4"
                            : undefined;

                        let lmp4URL =
                          this.getAppContext().getApiStoreService().getCluster() +
                          this.getAppContext().conf.API_PATH +
                          "/utils/chromescreenstream/" +
                          this.props.match.params.probeuid +
                          "/" +
                          this.props.match.params.measureid +
                          "/" +
                          this.props.bssid.replace(/:/g, "") +
                          "/" +
                          chromiumLmp4 +
                          "?token=" +
                          this.getAppContext().authHandler.getToken();
                        fetch(lmp4URL)
                          .then((response) => response.text())
                          .then((url) => {
                            let parsedURL = "https://" + url;
                            let objVideo = {
                              url: parsedURL,
                              chromiumLmp4: chromiumLmp4,
                              bssid: this.props.bssid.replace(/:/g, ""),
                              size: chromiumSize,
                            };
                            this.props._overlap_modal_video.open(objVideo);
                          });
                      }}
                      className="icon-file-video button-card pr-1"
                    />
                  )}

                {/* screen png */}
                {this.props.box_data.result != "_HEADING_" &&
                  this.props.box_data.screendocid && (
                    <span
                      title={this.props.box_data.screendoctitle || "View image"}
                      onClick={(e) => {
                        e.stopPropagation();

                        let chromiumPng = this.props.box_data.screendocid
                          ? this.props.res_id +
                            "." +
                            this.props.box_data.screendocid +
                            ".png"
                          : undefined;

                        let objPng = {
                          url:
                            this.getAppContext().getApiStoreService().getCluster() +
                            this.getAppContext().conf.API_PATH +
                            "/utils/chromescreenstream/" +
                            this.props.match.params.probeuid +
                            "/" +
                            this.props.match.params.measureid +
                            "/" +
                            this.props.bssid.replace(/:/g, "") +
                            "/" +
                            chromiumPng +
                            "?token=" +
                            this.getAppContext().authHandler.getToken(),
                          chromiumJpeg: chromiumPng,
                          bssid: this.props.bssid.replace(/:/g, ""),
                          screendoctitle: this.props.box_data.screendoctitle || undefined,
                        };
                        this.props._overlap_modal_screen.open(objPng);
                      }}
                      className="icon-picture button-card pr-1"
                    />
                  )}

                {this.props.box_data.result != "_HEADING_" &&
                  this.props.box_data.logcatid && (
                    <span
                      title="View .logcat"
                      onClick={(e) => {
                        e.stopPropagation();
                        let chromiumLogcat =
                          this.props.res_id +
                          "." +
                          this.props.box_data.logcatid +
                          ".logcat";

                        this.props.viewLogcat(
                          this.props.bssid.replace(/:/g, ""),
                          chromiumLogcat
                        );
                      }}
                      className="icon-file-log button-card pr-1"
                    />
                  )}
                {this.props.box_data.result != "_HEADING_" &&
                  this.props.box_data.harid && (
                    <span
                      title="View .har"
                      onClick={(e) => {
                        e.stopPropagation();
                        let chromiumHar =
                          this.props.res_id + "." + this.props.box_data.harid + ".har";
                        this.props.viewHar(
                          this.props.bssid.replace(/:/g, ""),
                          chromiumHar
                        );
                      }}
                      className="icon-file-har button-card pr-1"
                    />
                  )}
                {this.props.box_data.result != "_HEADING_" &&
                  this.props.box_data.pdfid && (
                    <span
                      title="Download .pdf"
                      onClick={(e) => {
                        e.stopPropagation();
                        let chromiumSize;
                        let _TMP_split = this.props.box_data.result.split("|");
                        _TMP_split.forEach((_C_data) => {
                          let _TMP_regex_res = /^\s*SIZE:\s(.*)\s*$/.exec(_C_data);
                          if (_TMP_regex_res) {
                            chromiumSize = parseFloat(_TMP_regex_res[1]).toFixed(1);
                          }
                        });
                        let chromiumPDF = this.props.box_data.pdfid
                          ? this.props.res_id + "." + this.props.box_data.pdfid + ".pdf"
                          : undefined;
                        let objPDF = {
                          url:
                            this.getAppContext().getApiStoreService().getCluster() +
                            this.getAppContext().conf.API_PATH +
                            "/utils/chromepdfstream/" +
                            this.props.match.params.probeuid +
                            "/" +
                            this.props.match.params.measureid +
                            "/" +
                            this.props.bssid.replace(/:/g, "") +
                            "/" +
                            chromiumPDF +
                            "?token=" +
                            this.getAppContext().authHandler.getToken(),
                          chromiumPDF: chromiumPDF,
                          bssid: this.props.bssid.replace(/:/g, ""),
                          size: chromiumSize,
                        };
                        window.open(objPDF.url);
                      }}
                      className="icon-file-pdf1 button-card"
                    />
                  )}
              </span>
            </div>{" "}
          </Col>

          <Col className="d-flex align-items-end flex-column">
            <div>
              {!this.props.box_data.end &&
                (!this.props.box_data.subStep ||
                  (this.props.box_data.subStep &&
                    this.props.box_data.result == "_HEADING_")) && (
                  <div className="">
                    <span
                      className={
                        "title-1 " +
                        (!/^-$/.test(this.props.box_data.summary[1])
                          ? this.props.box_data.summary[1] == "nan"
                            ? "icon-minus text-gray500"
                            : /^(\d+)$/.test(this.props.box_data.summary[1])
                            ? "icon-check1 text-success"
                            : "icon-close-outline text-danger"
                          : "")
                      }
                    />
                  </div>
                )}

              {this.props.box_data.subStep &&
                this.props.box_data.result != "_HEADING_" && (
                  <div className="mr-2">
                    <strong>...</strong>
                  </div>
                )}
            </div>
            {/* VIEW STEP */}

            {this.props.box_data.result != "_HEADING_" &&
              this.props.box_data.result &&
              !this.props.box_data.discearly && (
                <div
                  className="mt-auto"
                  style={this.props.box_data.end ? { marginTop: "4em" } : {}}
                >
                  {this.props.collapse == this.props.card_id &&
                    !this.props.box_data.jpegid && (
                      <div className="">
                        <ReactOButton
                          className="mr-1 " //mt-3
                          size="md"
                          color="secondary"
                          icon="new-tab"
                          text
                          onClick={(e) => {
                            e.stopPropagation();
                            let _toSend = {
                              api: {
                                probeuid: this.props.match.params.probeuid,
                                measureid: this.props.match.params.measureid,
                                bssid: this.props.match.params.bssid,
                                ts: this.props.match.params.ts,
                              },
                              ref: {
                                name: this.props.box_data.name,
                                phase: this.props.box_data.summary,
                                selectedResult: this.props.selectedResult,
                                originUrl: this.props.match.url,
                                final: false,
                              },
                            };
                            this.props.viewStep(_toSend);
                          }}
                        />
                        {/* <span className="mr-1 mt-3 text-muted icon-new-tab" /> */}
                      </div>
                    )}

                  <div
                    className="text-muted mt-2"
                    style={{ fontSize: "18px", marginLeft: "-4px" }}
                  >
                    {this.props.collapse == this.props.card_id ? (
                      <span className="title-2 text-muted icon-caret-up-outline" />
                    ) : (
                      <span className="title-2 text-muted icon-caret-down-outline" />
                    )}
                  </div>
                </div>
              )}
          </Col>
        </Row>
      </Panel>
    );
  }
}

// export default contextProvider(StepCard, {
//   define: null,
// });

export default contextProvider(withRouter(StepCard), {});
